/**
 * @GENERATED from Figma node 693:15929
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const MarketoBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#5C4C9F"
      d="M21 18.522V4.057L15.632 1v22zM8.809 2.912l4.325 1.34v13.943l-4.325 1.978zM6.31 5.756l-3.294-.555L3 17.688l3.31-.915z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(MarketoBright);
export { ForwardRef as MarketoBright };
